"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelectionSelectInput = void 0;
var react_1 = __importDefault(require("react"));
var models_1 = require("../../../models");
var ErrorMessage_1 = require("../ErrorMessage");
var FieldHeading_1 = require("../FieldHeading");
var PropertyInputWrapper_1 = require("../PropertyInputWrapper");
var Select_1 = require("../Select");
var shared_1 = require("./shared");
var SingleSelectionSelectInput = function (_a) {
    var propertyId = _a.propertyId, value = _a.value, errorMessages = _a.errorMessages, disabled = _a.disabled, className = _a.className, displayError = _a.displayError, items = _a.items, displayChoiceNumber = _a.displayChoiceNumber, currentTime = _a.currentTime, registrationLimitHideOption = _a.registrationLimitHideOption, onSelectChange = _a.onSelectChange;
    var hideRemain = registrationLimitHideOption.hideRemain, hideDeadlineExceededOption = registrationLimitHideOption.hideDeadlineExceededOption, hideUpperLimitReachedOption = registrationLimitHideOption.hideUpperLimitReachedOption;
    var handleSelectChange = function (e) {
        if (e.target.value === '') {
            onSelectChange(null);
            return;
        }
        onSelectChange(Number(e.target.value));
    };
    var unselectedItem = items.find(function (item) { return item.value == null; });
    var nonNullableItems = items.filter(function (item) { return item.value != null; });
    return (react_1.default.createElement(PropertyInputWrapper_1.PropertyInputWrapper, { propertyId: propertyId, propertyType: models_1.PROPERTY_TYPE.singleSelection, inputFormatType: models_1.SINGLE_SELECTION_PROPERTY_INPUT_TYPE.pulldown, errorMessages: errorMessages, className: className, displayError: displayError },
        react_1.default.createElement(Select_1.Select, { "data-cy-property-item": true, value: (0, shared_1.convertItemValueIntoInputValue)(value), error: displayError, disabled: disabled, onChange: handleSelectChange, "aria-labelledby": (0, FieldHeading_1.getLabelId)(propertyId), "aria-invalid": displayError, "aria-errormessage": (0, ErrorMessage_1.getFieldErrorMessageId)(propertyId), id: propertyId },
            unselectedItem && (react_1.default.createElement("option", { value: (0, shared_1.convertItemValueIntoInputValue)(unselectedItem.value) }, unselectedItem.label)),
            nonNullableItems
                .filter(function (item) {
                return !(0, shared_1.dropOption)(item, !!hideUpperLimitReachedOption, !!hideDeadlineExceededOption, currentTime);
            })
                .map(function (item, i) {
                var isDeadlineExceeded = (0, shared_1.deadlineExceeded)(item, currentTime);
                var isInvalidByRegistrationLimit = !item.isAnswered &&
                    ((0, shared_1.reachedUpperLimit)(item) || isDeadlineExceeded);
                return (react_1.default.createElement("option", { key: item.value, value: (0, shared_1.convertItemValueIntoInputValue)(item.value), disabled: isInvalidByRegistrationLimit },
                    displayChoiceNumber ? "".concat(i + 1, ". ").concat(item.label) : item.label,
                    getRegistrationLimitStatus(isDeadlineExceeded, item.remain, !!hideRemain)));
            }))));
};
exports.SingleSelectionSelectInput = SingleSelectionSelectInput;
var getRegistrationLimitStatus = function (deadlineExceeded, remain, hideRemain) {
    if (remain == null) {
        return null;
    }
    if (remain <= 0) {
        return '（残りなし）';
    }
    if (deadlineExceeded) {
        return '（期限が過ぎました）';
    }
    if (hideRemain) {
        return null;
    }
    return "\uFF08\u6B8B\u308A".concat(remain, "\uFF09");
};
